var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCitedPaper = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 55",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.863.577H28.44L41.137 13.56v41.02H.863V.576z",
    fill: "#194BB0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.136 13.39L28.322.577v12.815h12.814z",
    fill: "#B29A43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.955 31.115c0 .79-.322 1.482-.966 2.074a3.178 3.178 0 01-2.25.89c-1.364 0-2.411-.452-3.143-1.353-.73-.901-1.097-2.148-1.097-3.74 0-1.482.627-2.976 1.878-4.482a12.369 12.369 0 014.556-3.426l.818 1.315c-1.4.679-2.498 1.47-3.291 2.37-.794.901-1.252 1.994-1.376 3.278h1.041c.769 0 1.395.087 1.878.26.483.172.874.413 1.171.722.285.296.484.623.595.981.124.358.186.728.186 1.111zm9.545 0c0 .79-.323 1.482-.967 2.074a3.178 3.178 0 01-2.25.89c-1.364 0-2.411-.452-3.142-1.353-.732-.901-1.097-2.148-1.097-3.74 0-1.482.626-2.976 1.878-4.482a12.368 12.368 0 014.555-3.426l.818 1.315c-1.4.679-2.498 1.47-3.291 2.37-.793.901-1.252 1.994-1.376 3.278h1.041c.769 0 1.395.087 1.878.26.484.172.874.413 1.172.722.285.296.483.623.595.981.123.358.186.728.186 1.111z",
    fill: "#fff"
  })));
};
export default SvgCitedPaper;